import { useEffect } from "react";
import WelcomeCard from "../components/dashboard/WelcomeCard";
import AppointmentStats from "../components/dashboard/AppointmentStats";
import AppointmentStatus from "../components/dashboard/AppointmentStatus";
import ProviderWorkload from "../components/dashboard/ProviderWorkload";
import { fetchAppointmentDetails } from "../redux/appointment-actions";
import { useDispatch, useSelector } from "react-redux";
import { fetchDoctors } from "../redux/doctors-actions";
import { useTour } from "../components/tour/TourProvider";
import { usePermission } from "../hooks/use-permission";

const toISODate = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

function Dashboard() {
  const dispatch = useDispatch();
  const loggedInDoctor = useSelector((state) => state.me.me);
  const myEmail = loggedInDoctor?.email;
  const { tour } = useTour();
  const canViewTodaysSchedule = usePermission("dashboard.todays_schedule", "read");
  const canViewStatusOverview = usePermission("dashboard.status_overview", "read");
  const canViewProviderWorkload = usePermission("dashboard.provider_workload", "read");
  const todayISO = toISODate(new Date());
  const doctors = useSelector((state) => state.doctors?.doctors || []);
  const clinicName = useSelector(
    (state) => state.me.me.clinicName
  );

  useEffect(() => {
    if (myEmail) {
      dispatch(fetchAppointmentDetails(myEmail, loggedInDoctor?.clinicName));
    }
  }, [dispatch, myEmail, loggedInDoctor?.clinicName]);

  useEffect(() => {
    if (doctors.length === 0) dispatch(fetchDoctors(clinicName));
  }, [doctors.length, dispatch, clinicName]);

  useEffect(() => {
    document.title = "Dashboard - Seismic Connect";
  }, []);

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center w-full" data-tour="welcome-card">
        <WelcomeCard />
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-6">
        {(canViewTodaysSchedule || tour?.active) && (
          <div data-tour="appointment-stats" className="h-full">
            <AppointmentStats date={todayISO} />
          </div>
        )}
        {(canViewStatusOverview || tour?.active) && (
          <div data-tour="appointment-status" className="h-full">
            <AppointmentStatus date={todayISO} />
          </div>
        )}
        {(canViewProviderWorkload || tour?.active) && (
          <div data-tour="provider-workload" className="h-full">
            <ProviderWorkload date={todayISO} />
          </div>
        )}
      </div>
    </div>
  );
}

export default Dashboard;
